import React, { FC, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { PATH_LIST } from "shared/lib/react-router";
import Button from "shared/ui/button";
import { ResponseCodes, sircapApi } from "shared/api/sircap";
import { useTranslation } from "react-i18next";
import { onboardModel } from "entities/onboard";
import { toast } from "react-toastify";
import { useStore } from "zustand";
import { sessionModel } from "entities/session";
import { ContentType } from "shared/api/http-client";
import { blobToFile } from "helpers/functions";
import { DocumentType } from "static/types";
import "./style.scss";
import { accountStore } from "entities/account";
import { firebaseLogEvent } from "app/libs/firebase";
import TakePhotoModal from "../components/take-photo-modal";
import SubmitPhotoModal from "../components/submit-photo-modal";
import { VerificationBtn } from "../components/button";
import File from "../../../../assets/verification/FileAttach.svg";
import OpenCameraButton from "widgets/open-camera-btn";

enum ModalStep {
  Zero,
  Photo,
  Submit,
}

export const ProofOfAddressPage = () => {
  const [step, setStep] = useState<ModalStep>(ModalStep.Zero);
  const [image, setImage] = useState<any>();
  const { synckyc } = useStore(accountStore);
  const [isSubmit, setIsSubmit] = useState(false);
  const { t: err } = useTranslation("errors");
  const { t: o } = useTranslation("onboarding");

  const navigate = useNavigate();
  const location = useLocation();

  // Get country from navigation state and console log it
  // useEffect(() => {
  //   const country = location.state?.country;
  //   console.log("Proof of Address - Country:", country);
  // }, [location.state]);

  const onOpen = () => {
    setStep(ModalStep.Photo);
  };

  const SubmitPhoto = async () => {
    setIsSubmit(true);
    const resp = await sircapApi.onboarding.document(
      {
        country: "",
        citizenship: location.state?.citizenship,
        idDocType: "UTILITY_BILL",
        fiz: blobToFile(image, `UTILITY_BILL.jpg`),
      },
      { type: ContentType.FormData }
    );
    if (resp.error) {
      toast.error(err(String(resp.error.code)));
    } else {
      const kyc = resp.data.data;
      synckyc(kyc);

      // navigate(PATH_LIST.account, {
      //   state: { verificationRequestModal: true },
      // });
      navigate(PATH_LIST.uploadCredentials);
    }
    setIsSubmit(false);
  };

  return (
    <>
      <div className="verification-selfie">
        <div className="verification-selfie-top">
          <img src={File} alt="PhoneNumber" />
          {/* <p className="register-title">{t("documentsConfirmingAddress")}</p>
          <span className="register-subtitle">
            {t("addressDocumentsExamples")}
          </span> */}
          <p className="register-title">{o("provideAddressDoc")}</p>
          <ul className="register-address-ul">
            <li>{o("passportAddressPage")}</li>
            <li>{o("governmentCertificate")}</li>
            <li>{o("rentalAgreement")}</li>
            <li>{o("workCertificate")}</li>
            <li>{o("otherDocument")}</li>
          </ul>
        </div>
        {/* <VerificationBtn onClick={onOpen} text={t("takeSelfie")} /> */}
        <OpenCameraButton onOpen={onOpen} />
      </div>

      {step === ModalStep.Photo && (
        <TakePhotoModal
          type={DocumentType.ProofAddress}
          onOpen={(image: any) => {
            setImage(image);
            setStep(ModalStep.Submit);
          }}
          onClose={() => {
            setStep(ModalStep.Zero);
          }}
        />
      )}

      {step === ModalStep.Submit && (
        <SubmitPhotoModal
          type={DocumentType.ProofAddress}
          onSubmit={SubmitPhoto}
          image={image}
          onClose={() => setStep(ModalStep.Photo)}
          isSubmit={isSubmit}
        />
      )}
    </>
  );
};
